<template>
  <button class="base-button font--b2 mobile-font--b3">
    <slot />
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  buttH: {
    type: String,
    required: false,
    default: "41px",
  },
  buttW: {
    type: String,
    required: false,
    default: "139px",
  },
  buttColor: {
    type: String,
    required: false,
    default: "var(--violet-main)",
  },
});
</script>

<style scoped lang="scss">
.base-button {
  width: v-bind(buttW);
  height: v-bind(buttH);
  background-color: v-bind(buttColor);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  border-radius: 40px;
  color: var(--white-monochrome);
  cursor: pointer;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
  &:hover {
    background-color: var(--violet-light);
  }
  &:active {
    background-color: var(--violet-dark);
  }
}

@media (max-width: 42rem) {
  .base-button {
    padding: 8px 28px;
    width: 100%;
    height: auto;
    max-width: 105px;
  }
  @include mobile-fonts;
}
</style>
